import { Link } from "react-router-dom";
import "./FrequentlyServices.scss";
import food from "../../assets/images/sidebar-icons/food.svg";
import foodCategory from "../../assets/images/sidebar-icons/food-category.svg";
import ingredients from "../../assets/images/sidebar-icons/ingredients.svg";
import guide from "../../assets/images/sidebar-icons/guide.svg";

const Services = [
  {
    id: 0,
    name: "غذاها",
    route: "/foods",
    image: food,
  },
  {
    id: 1,
    name: "دسته بندی ها",
    route: "/categories",
    image: foodCategory,
  },
  {
    id: 2,
    name: "محتویات",
    route: "/contents",
    image: ingredients,
  }
  ,
  {
    id: 2,
    name: "راهنما",
    route: "/learn-how-to-use-panel",
    image: guide,
  }
];

const FrequentlyServices = () => {
  return (
    <div className="customized-container">
      <div className="customized-wrapper">
        <div className="services-container">
          {Services.map((service) => {
            return (
              <Link to={service.route} key={service.id}>
                <div className="service-container">
                  <img src={service.image} alt="service-logo" />
                  <p>{service.name}</p>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default FrequentlyServices;
